import useReveal from "@/hooks/useReveal";

export default function Reveal({ children, className = "", delay = 0 }) {
  const ref = useReveal();
  return <div ref={ref} className={`motion-reveal ${className}`} style={{ "--delay": `${delay}ms` }}>{children}</div>;
}
